import { Checkbox, Flex, Radio, Text } from '@byecode/ui'
import React, { useCallback } from 'react'
import styled from 'styled-components'

import { useUnifiedTap } from '../../../../../hooks'
import { Item } from './Item'

export type TagGroupOption = {
    label: string
    value: string
    color?: string
}

const SCxCheckboxWrapper = styled(Flex)<{ disabled?: boolean }>`
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : undefined)};
    opacity: ${({ disabled }) => (disabled ? '0.4 ' : undefined)};
`

export interface TagGroupOptionItemProps {
    option: TagGroupOption
    checked: boolean
    color: string | undefined
    colorless?: boolean
    disabled?: boolean
    isMultiple: boolean
    value: string[]
    onChange: (next: string[]) => void
}

export const TagGroupOptionItem: React.FC<TagGroupOptionItemProps> = ({
    option,
    checked,
    color,
    colorless,
    disabled,
    isMultiple,
    value,
    onChange
}) => {
    const applyChange = useCallback(() => {
        if (disabled) {
            return
        }
        if (isMultiple) {
            onChange(checked ? value.filter(v => v !== option.value) : [...value, option.value])
        } else {
            onChange(checked ? [] : [option.value])
        }
    }, [disabled, isMultiple, checked, value, option.value, onChange])

    const tapHandlers = useUnifiedTap(applyChange)

    if (isMultiple) {
        return (
            <Item
                data={option}
                colorless={colorless}
                prefix={
                    colorless ? null : (
                        <SCxCheckboxWrapper gap={8} disabled={disabled}>
                            <Checkbox checked={checked} radius="50%" color={color} size="xs" value={option.value} />
                            <Text>{option.label}</Text>
                        </SCxCheckboxWrapper>
                    )
                }
                {...tapHandlers}
            />
        )
    }

    return (
        <Item
            isActive={checked}
            prefix={
                colorless ? null : (
                    <Radio
                        size="xs"
                        style={{ padding: 0, gap: 6 }}
                        styles={{
                            radio: {
                                backgroundColor: 'var(--color-white)',
                                borderRadius: '100%'
                            },
                            input: {
                                width: '16px!important',
                                height: '16px!important',
                                borderColor: `${checked ? color : 'rgba(0,0,0,0.1)'}!important`
                            },
                            icon: {
                                width: '8px!important',
                                height: '8px!important',
                                left: '4px!important',
                                top: '4px!important'
                            }
                        }}
                        label={option.label}
                        color={checked ? color : 'transparent'}
                        checked={checked}
                        disabled={disabled}
                    />
                )
            }
            colorless={colorless}
            data={option}
            {...tapHandlers}
        />
    )
}
